import {groupBy, mapObject} from '@benchling/js-utils';
import {useMemo} from 'react';

import {filteredResidues} from 'molbio/aa-sequences/AminoAcids';
import AaSequenceConstants, {AaSequenceAlignmentSLA} from 'molbio/aa-sequences/util/AaSequenceConstants';

/**
 * A memoized mapping of color to what glyphs should use that color in the Protein sequence map
 * @param aminoAcids The amino acids for this slice
 * @param getColor A function that gets the intended color for a single amino acid
 */
export default function useGlyphsByColor({
  aminoAcids,
  getColor,
}: {
  aminoAcids: string;
  getColor: (aminoAcid: AaSequenceAlignmentSLA) => string;
}): {[color: string]: string} {
  return useMemo(() => {
    // Mapping from color to a list of individual codons / glyphs that should use that color
    const aasByColor = groupBy<AaSequenceAlignmentSLA, string>(
      AaSequenceConstants.ALIGNMENT_AMINO_ACIDS as Array<AaSequenceAlignmentSLA>,
      getColor
    );
    return mapObject<Array<AaSequenceAlignmentSLA>, string>(
      aasByColor,
      (aasOfColor: Array<AaSequenceAlignmentSLA>) => filteredResidues(aminoAcids, aasOfColor)
    );
  }, [aminoAcids, getColor]);
}
